<template>
  <div class="form-wrapper">
    <div
      :class="[
        'form-wrapper__header',
        { 'form-wrapper__header--altcolor': altcolor }
      ]"
    >
      {{ title }}
      <component :is="icon" />
    </div>
    <div class="form-wrapper__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFormWrapper",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: Object,
      default: () => {}
    },
    altcolor: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  border-bottom: 1px solid $color-grey-100;
  padding: 30px 0;

  &__header {
    font-size: $font-size-xl;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $color-blue-300;

    &--altcolor {
      color: $color-blue-200;
    }
  }

  &__content {
    margin-top: 25px;
  }
}
</style>
